var map = {
	"./inactivecardmanagement.svg": 70711,
	"./inactiveconcession.svg": 76296,
	"./inactivedealer.svg": 23507,
	"./inactivedepot.svg": 30110,
	"./inactivedrystock order.svg": 37415,
	"./inactiveinventory.svg": 39148,
	"./inactivepaymentinflow.svg": 115,
	"./inactiveprogram.svg": 56980,
	"./inactiverefundrequest.svg": 95637,
	"./inactivesupport.svg": 73693,
	"./inactiveteams.svg": 97218,
	"./inactiveusers.svg": 54920
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72428;